module.exports = __webpack_public_path__ + "img/brand-type2.35318a0a.svg";